<section data-cy="about-section">
    <h4 data-cy="about-heading">User Information</h4>
    <p-table [value]="aboutInfo" data-cy="about-info-table">
        <ng-template #body let-info>
            <tr data-cy="about-info-row">
                <td data-cy="about-info-label">{{ info.label }}</td>
                <td data-cy="about-info-value">{{ info.value }}</td>
            </tr>
        </ng-template>
    </p-table>
</section>
